module.exports = __webpack_public_path__ + "static/nowoczesnie-94e641681373ce1993528f39ff83dabf.svg";